import type { AccrualVsCashComparison } from "@/lib/reporting.api";
import { formatXaf } from "../creancesEngagements.formatters";
import { MetricTile } from "./MetricTile";

export function AccrualCashComparisonSection({
  comparison,
}: {
  comparison: AccrualVsCashComparison;
}) {
  const gap = comparison.accrual.totalGross - comparison.cash.totalGross;

  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <p className="mb-0.5 text-[11.5px] font-semibold text-body">
        Ce qu'on gagne vs. ce qu'on encaisse réellement
      </p>
      <p className="mb-3 text-[10.5px] text-muted-foreground">
        Engagement (facturé) et Encaissement (payé) pour la même période, côte à côte.
      </p>
      {/* Engagement vs Encaissement shown side by side, not as a toggle:
          "combien on gagne" and "combien on gagne réellement" are two
          different questions worth seeing at once. */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <MetricTile
          label="Engagement"
          value={formatXaf(comparison.accrual.totalGross)}
          detail="CA brut facturé"
          gain={formatXaf(comparison.accrual.totalGain)}
        />
        <MetricTile
          label="Encaissement"
          value={formatXaf(comparison.cash.totalGross)}
          detail="Argent réellement reçu"
          gain={formatXaf(comparison.cash.totalGain)}
          tone="success"
        />
      </div>
      {gap > 0 && (
        <p className="mt-3 rounded border border-warning-border bg-warning-bg px-2.5 py-1.5 text-[10.5px] text-warning-text">
          L'écart entre les deux ({formatXaf(gap)}) représente ce qui est facturé mais pas
          encore encaissé.
        </p>
      )}
    </div>
  );
}
